<mat-accordion>
  <mat-expansion-panel [expanded]="this.step?.event?.selectedIndex-1 === 0" hideToggle>
    <mat-expansion-panel-header>
      <mat-panel-title>
        <div class="title_wrap">
          <span class="number">1</span>
          <span class="title">Staff Information</span>
        </div>

      </mat-panel-title>
    </mat-expansion-panel-header>
    <div class="wrapper">
      <img src="../../../../assets/img/general_icons/Group 11353.svg" alt="icon" class="icon">
      <div class="wrap">
        <span class="label">HR code</span>
        <span class="value">{{staffInformation?.hr_code}}</span>
      </div>
    </div>
    <div class="wrapper">
      <img src="../../../../assets/img/general_icons/Group 11353.svg" alt="icon" class="icon">
      <div class="wrap">
        <span class="label">First Name*</span>
        <span class="value">{{staffInformation?.first_name}}</span>
      </div>
    </div>
    <div class="wrapper" >
      <img src="../../../../assets/img/general_icons/Group 11353.svg" alt="icon" class="icon">
      <div class="wrap">
        <span class="label">Last Name*</span>
        {{staffInformation?.last_name}}
      </div>
    </div>
    <div class="wrapper" >
      <img src="../../../../assets/img/general_icons/Group 11356.svg" alt="icon" class="icon">
      <div class="wrap">
        <span class="label">Email*</span>
        <span class="value">{{staffInformation?.email}}</span>
      </div>
    </div>

    <div class="wrapper" >
      <img src="../../../../assets/img/general_icons/Group 11356.svg" alt="icon" class="icon">
      <div class="wrap">
        <span class="label">Default Office*</span>
        {{staffInformation?.current_tenent?.name}}
      </div>
    </div>

    <div class="wrapper" >
      <img src="../../../../assets/img/general_icons/Group 11356.svg" alt="icon" class="icon">
      <div class="wrap">
        <span class="label">Offices*</span>
        @for (tenant of staffInformation?.attach_tenents; track tenant) {
          <label>
            {{ tenant.name }}, &nbsp;
          </label>
        }
      </div>
    </div>

  </mat-expansion-panel>
  <mat-expansion-panel [expanded]="this.step?.event?.selectedIndex-1 === 1"  hideToggle>
    <mat-expansion-panel-header>
      <mat-panel-title>
        <div class="title_wrap">
          <span class="number">2</span>
          <span class="title">Staff Detail</span>
        </div>

      </mat-panel-title>
    </mat-expansion-panel-header>
    <div class="wrapper">
      <img src="../../../../assets/img/general_icons/Group 7925.svg" alt="icon" class="icon">
      <div class="wrap">
        <span class="label">Phone Number*</span>
        <span class="value">{{staffDetail?.phone_number}}</span>
      </div>
    </div>

    <div class="wrapper">
      <img src="../../../../assets/img/general_icons/Group 7931.svg" alt="icon" class="icon">
      <div class="wrap">
        <span class="label">Staff Department*</span>
        @if (staffDetail?.department?.name) {
          <span class="value">
            {{ staffDetail?.department?.name }}
          </span>
        }
        @if (!staffDetail?.department?.name && staffDetail?.department) {
          <span class="value">
            {{ staffDetail.department }}
          </span>
        }
      </div>
    </div>

    <div class="wrapper">
      <img src="../../../../assets/img/general_icons/Group 7925.svg" alt="icon" class="icon">
      <div class="wrap">
        <span class="label">Start Date *</span>
        <span class="value">{{ staffDetail?.start_date| date: 'MM/dd/yyyy'}}</span>
      </div>
    </div>
    <div class="wrapper">
      <img src="../../../../assets/img/general_icons/Group 7925.svg" alt="icon" class="icon">
      <div class="wrap">
        <span class="label">Birthday *</span>
        <span class="value">{{ staffDetail?.birthday | date: 'MM/dd/yyyy'}}</span>
      </div>
    </div>

    <div class="wrapper">
      <img src="../../../../assets/img/general_icons/Group 7929.svg" alt="icon" class="icon">
      <div class="wrap">
        <span class="label">Timezone*</span>
        @if (staffDetail?.time_zone?.zone) {
          <span class="value">
            {{ staffDetail?.time_zone?.zone }}
          </span>
        }
        @if (!staffDetail?.time_zone?.zone && staffDetail?.time_zone) {
          <span class="value">
            {{ staffDetail?.time_zone }}
          </span>
        }
      </div>
    </div>

    <div class="wrapper">
      <img src="../../../../assets/img/general_icons/Group 7929.svg" alt="icon" class="icon">
      <div class="wrap">
        <span class="label">Language*</span>
        @if (staffDetail?.language?.name) {
          <span class="value">
            {{ staffDetail?.language?.name }}
          </span>
        }
        @if (!staffDetail?.language?.name && staffDetail?.language) {
          <span class="value">
            {{ staffDetail?.language }}
          </span>
        }
      </div>
    </div>
    <div class="wrapper">
      <img src="../../../../assets/img/general_icons/Group 7929.svg" alt="icon" class="icon">
      <div class="wrap">
        <span class="label">Roles*</span>
        @for (role of staffDetail?.roles; track role) {
          <span class="value">{{role?.name}}</span>
        }
        <!-- <span class="value" *ngIf="staffDetail?.role?.name">
        {{ staffDetail?.role?.name }}
      </span>
      <span class="value" *ngIf="!staffDetail?.role?.name && staffDetail?.role">
        {{ staffDetail?.role }}
      </span> -->
    </div>
  </div>

</mat-expansion-panel>

<mat-expansion-panel [expanded]="this.step?.event?.selectedIndex-1 === 2"  hideToggle>
  <mat-expansion-panel-header>
    <mat-panel-title>
      <div class="title_wrap">
        <span class="number">4</span>
        <span class="title">Address</span>
      </div>
    </mat-panel-title>
  </mat-expansion-panel-header>
  <div class="wrapper">
    <img src="../../../../assets/img/location_icon.svg" alt="icon" class="icon">
    <div class="wrap">
      <span class="label">Address Line 1 *</span>
      <span class="value">{{staffAddress?.staff_address?.address_line_1}}</span>
    </div>
  </div>
  <div class="wrapper">
    <img src="../../../../assets/img/location_icon.svg" alt="icon" class="icon">
    <div class="wrap">
      <span class="label">Address Line 2</span>
      <span class="value">{{staffAddress?.staff_address?.address_line_2}}</span>
    </div>
  </div>
  <div class="wrapper">
    <img src="../../../../assets/img/city_icon.svg" alt="icon" class="icon">
    <div class="wrap">
      <span class="label">City*</span>
      <span class="value">{{staffAddress?.staff_address?.city}}</span>
    </div>
  </div>
  <div class="wrapper">
    <img src="../../../../assets/img/state_icon.svg" alt="icon" class="icon">
    <div class="wrap">
      <span class="label">State*</span>
      <span class="value">{{staffAddress?.staff_address?.state_id?.name}}</span>
    </div>
  </div>
  <div class="wrapper">
    <img src="../../../../assets/img/zipcode_icon.svg" alt="icon" class="icon">
    <div class="wrap">
      <span class="label">Zip Code*</span>
      <span class="value">{{staffAddress?.staff_address?.zipcode}}</span>
    </div>
  </div>
</mat-expansion-panel>


<mat-expansion-panel [expanded]="this.step?.event?.selectedIndex-1 === 3"  hideToggle>
  <mat-expansion-panel-header>
    <mat-panel-title>
      <div class="title_wrap">
        <span class="number">3</span>
        <span class="title">Salary</span>
      </div>

    </mat-panel-title>
  </mat-expansion-panel-header>
  <div class="wrapper">
    <img src="../../../../assets/img/general_icons/Group 7933.svg" alt="icon" class="icon">
    <div class="wrap">
      <span class="label">Salary*</span>
      <span class="value">{{salary?.salary | currency}}</span>
    </div>
  </div>
</mat-expansion-panel>

<!-- Certification section - only show in create mode -->
@if (!isEdit) {
  <mat-expansion-panel hideToggle>
    <mat-expansion-panel-header>
      <mat-panel-title>
        <div class="title_wrap">
          <span class="number">5</span>
          <span class="title">Certification</span>
        </div>
      </mat-panel-title>
    </mat-expansion-panel-header>
    @for (certificate of staffCertificates?.certificates; track certificate) {
      <div>
        @if (certificate?.is_certified) {
          <div class="wrapper">
            <img src="../../../../assets/img/general_icons/Icon material-account-balance-wallet.png" alt="icon" class="icon">
            <div class="wrap">
              <span class="label">{{certificate?.name}}</span>
              @if (certificate?.expiration_date) {
                <span class="value">{{certificate?.expiration_date | date}}</span>
              }
              @if (certificate?.file_name) {
                <span class="value">{{getFileName(certificate?.file_name)}}</span>
              }
            </div>
          </div>
        }
      </div>
    }
  </mat-expansion-panel>
}
</mat-accordion>
